import { Box, Button, IconButton, Tooltip } from "@mui/material"
import Datatable from "../../../components/features/Datatable"
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useRef, useState } from "react";
import BsModal from "../../../components/common/BaseModal";
import { DeleteIconButton, EditIconButton } from "../../../../assets/common-svg/CommonSvg";
import DeleteModal from "../../../components/common/BaseModal/DeleteModal";
import { deleteCountry, disableAddModal, enableAddModal, fetchAllCountry } from "../../../slices/country";
import AddCountryForm from "./addCountrymodal";

const matchesCountrySearch = (item, searchValue) => {
    const normalizedSearch = searchValue.trim().toLowerCase();

    if (!normalizedSearch) return true;

    return [
        item?.name,
        item?.country_code,
    ].some((value) => String(value || "").toLowerCase().includes(normalizedSearch));
};

const CountryManagement = () => {
    const dispatch = useDispatch()
    const [rowData, setRowData] = useState(null)
    const [open, setOpen] = useState(false)
    const [loading, setLoading] = useState(false)
    const { isLoading, addModal } = useSelector((state) => state.bmrCountry);
    const [filters, setFilters] = useState({});
    const [currentSearch, setCurrentSearch] = useState("");
    const [countryData, setCountryData] = useState({
        items: [],
        total_count: 0,
        page: 1,
        per_page: 10,
    })
    const searchDebounceRef = useRef(null);
    const columns = [
        {
            id: 'id',
            name: 'Country ID',
            align: "left",
            selector: row => row.id,
            sortable: true
        },
        {
            id: 'name',
            name: 'Country Name',
            align: "center",
            selector: row => row.name,
            sortable: true
        },
        {
            id: 'country_code',
            align: "center",
            name: 'Country Code',
            selector: row => row.country_code,
            sortable: true
        },
        
        {
            name: 'Action',
            align: "center",
            selector: row => <Box key={row.id}>
                <Tooltip title="Edit" >
                    <span>
                        <IconButton
                            onClick={() => { setRowData(row), handleAddModal() }}
                        >
                            <EditIconButton
                                bgColor={"#C3C3C3"}
                            />
                        </IconButton>
                    </span>
                </Tooltip>
                <Tooltip title={row.is_used ? "Cannot delete: Country is in use" : "Delete"} >
                       <span style={{ 
        cursor: row.is_used ? 'not-allowed' : 'pointer',
        display: 'inline-block',
        pointerEvents: row.is_used ? 'all' : 'auto' 
    }}>
                        <IconButton
                            onClick={() => { if (!row.is_used) { setRowData(row); setOpen(true); } }}
              sx={{
              pointerEvents: row.is_used ? 'none' : 'auto', 
            }}
                        >
                            <DeleteIconButton
                                bgColor={"#FA5151"}
                            />
                        </IconButton>
                    </span>
                </Tooltip>
            </Box>,
        },
    ];

    const handleCloseModal = async () => {
        await dispatch(disableAddModal())
    }
    const handleAddModal = async () => {
        await dispatch(enableAddModal())
    }
    const removeCountry= async () => {
    const { id } = rowData;
    await dispatch(deleteCountry({ id }));
    setOpen(false);
    handleServerSideChange({
        page: countryData.page,
        per_page: countryData.per_page,
        search: currentSearch
    });
};
   const handleServerSideChange = async (params) => {
    const searchValue = params.search || '';
    const currentPage = params.page || 1;
    const currentPerPage = params.per_page || countryData.per_page || 10;
    setCurrentSearch(searchValue);
    const trimmedSearch = searchValue.trim();

    try {
        setLoading(true);

        if (trimmedSearch === '') {
            const result = await dispatch(fetchAllCountry({
                page: currentPage,
                limit: currentPerPage,
                sort_by: params.sort_by || 'id',
                order_by: params.sort_order || 'desc'
            })).unwrap();

            setCountryData({
                items: result?.data || [],
                total_count: result?.page_details?.no_of_records || 0,
                page: result?.page_details?.page || currentPage,
                per_page: result?.page_details?.limit || currentPerPage,
            });

        } else {
            const shouldSearchCountryCode =
                trimmedSearch.length <= 3 &&
                !trimmedSearch.includes(" ");

            const searchRequests = [
                dispatch(fetchAllCountry({
                    page: 1,
                    limit: currentPerPage,
                    name: trimmedSearch,
                    sort_by: params.sort_by || 'id',
                    order_by: params.sort_order || 'desc'
                })).unwrap()
            ];

            if (shouldSearchCountryCode) {
                searchRequests.push(
                    dispatch(fetchAllCountry({
                        page: 1,
                        limit: currentPerPage,
                        country_code: trimmedSearch.toUpperCase(),
                        sort_by: params.sort_by || 'id',
                        order_by: params.sort_order || 'desc'
                    })).unwrap()
                );
            }

            const [countryResult, countryCodeResult] = await Promise.all(searchRequests);

            const countryItems = countryResult?.data || [];
            const countryCodeItems = countryCodeResult?.data || [];

            const merged = [...countryItems, ...countryCodeItems].filter(
                (item, index, self) => index === self.findIndex(i => i.id === item.id)
            );
            const filteredItems = merged.filter((item) => matchesCountrySearch(item, trimmedSearch));
            const startIndex = (currentPage - 1) * currentPerPage;
            const paginatedItems = filteredItems.slice(startIndex, startIndex + currentPerPage);

            setCountryData({
                items: paginatedItems,
                total_count: filteredItems.length,
                page: currentPage,
                per_page: currentPerPage,
            });
        }

    } catch (error) {
        console.error("Error fetching country list:", error);
    } finally {
        setLoading(false);
    }
}
const updateFilter = (params) => {
        const {
            page = 1,
            per_page = 10,
            search = '',
            ...appliedFilters
        } = params;

        const isFilterChanged = JSON.stringify(filters) !== JSON.stringify(appliedFilters);
        const finalPage = isFilterChanged ? 1 : page;

        setFilters(appliedFilters);
  const isSearchChange = search !== currentSearch;
    if (isSearchChange) {
        if (searchDebounceRef.current) clearTimeout(searchDebounceRef.current);
        searchDebounceRef.current = setTimeout(() => {
            handleServerSideChange({
                page: finalPage,
                per_page,
                search,
                sort_by: params.sort_by,
                sort_order: params.sort_order
            });
        }, 400);
    } else {
        handleServerSideChange({
            page: finalPage,
            per_page,
            search,
            sort_by: params.sort_by,
            sort_order: params.sort_order
        });
    }
    };

    useEffect(() => {
        handleServerSideChange({ page: 1, per_page: 10, search: "" });
    }, []);
    return <div className="!p-6">
        <div className="!p-4 mt-3 bg-white flex flex-col gap-4">
            <BsModal
                open={addModal}
                onClose={handleCloseModal}
                title={rowData ? "Edit Country" : "Add New Country"}>
                <AddCountryForm editData={rowData}  onSuccess={() => {
        handleCloseModal();
        handleServerSideChange({ 
            page: countryData.page,      
            per_page: countryData.per_page, 
            search: currentSearch     
        });
        setRowData(null);
    }}   />
            </BsModal>
            <Datatable
                columns={columns}
                data={{
                    items: countryData.items,
                    total_count: countryData.total_count
                }}
                title="Country"
                searchPlaceholder="Search by Country name"
                loading={isLoading || loading}
                BtnComponent={<Button className="ml-2"
                    onClick={() => (handleAddModal(), setRowData(null))}
                >Add New Country</Button>}
                remote={true}
                onServerSideChange={updateFilter}
            />
            <DeleteModal
                open={open}
                setClose={setOpen}
                title={"Are you sure you want to Delete ?"}
                buttonText={"Delete"}
                handleSuccess={removeCountry}
            />
        </div>
    </div>
}
export default CountryManagement
